/* eslint-disable no-param-reassign */
import { createSortNumeric } from 'aegion_common_utilities/lib/Sort';
import _ from 'lodash';



/** ************ 
 * SORT NA LAST
 */

const NA_NAMES = ['NA', 'NA1', 'NA2', 'NA123', 'NA*'];
const INVALID_NAMES = ['', ' ', '  ', '   ', undefined, null]

const _createGetNamePriority = (nameProp) => (u) => {
			const name = u[nameProp];
			if (NA_NAMES.indexOf(name) > -1) {
				return 1;
			}

			if (INVALID_NAMES.indexOf(name) > -1) {
				return 2;
			}

			return 0;
		}

export const sortCtFilterItemsNALast = createSortNumeric(
	'ASC', 
	{ 
		getValue: _createGetNamePriority('ctName'),
		invalidLast: true
	}
)

export const sortPmFilterItemsNALast = createSortNumeric(
	'ASC', 
	{ 
		getValue: _createGetNamePriority('pmName'),
		invalidLast: true
	}
)

export const sortCtFilterStoreNaLast = (ctFilterStore) => {
	const customers = Object.keys(ctFilterStore);
	return customers.reduce((acc, customerName) => {
		const users = ctFilterStore[customerName];
		acc[customerName] = users.sort(sortCtFilterItemsNALast);
		return acc;
	}, {});
}

export const sortPmFilterStoreNaLast = (pmFilterStore) => {
	const customers = Object.keys(pmFilterStore);
	return customers.reduce((acc, customerName) => {
		const users = pmFilterStore[customerName];
		acc[customerName] = users.sort(sortPmFilterItemsNALast);
		return acc;
	}, {});
}





/** ************ 
 * UNSHRINK
 */

const unshrinkUserFilterItem = (user) => {
	const shrinkKeys = [
		'jobIds',
		'lineIds',
		'entityIds',
		'areaIds',
		'pipeIds',
		'regulatoryStatusIds',
	];
	let clone = _.cloneDeep(user);
	clone = shrinkKeys.reduce((acc, key) => {
		if (clone[key] instanceof Array) {
			clone[key] = clone[key].reduce((acc2, val) => {
				acc2[val] = true;
				return acc2;
			}, {});
		}
		return acc;
	}, clone);
	
	return clone;
}

export const unshrinkUserFilterItems = (ctsMapByCustomer) => {
	const customers = Object.keys(ctsMapByCustomer);
	return customers.reduce((acc, customerName) => {
		const users = ctsMapByCustomer[customerName];
		acc[customerName] = users.map(u => unshrinkUserFilterItem(u));
		return acc;
	}, {})
}

export default {
	unshrinkUserFilterItems,
	sortPmFilterItemsNALast,
	sortCtFilterItemsNALast,
	sortPmFilterStoreNaLast,
	sortCtFilterStoreNaLast,
};